import './sign-up.component.scss'

import $ from 'jquery'

$(document).ready(function () {
  window.signUp = {
    currentStep: 0,
    getStep: function (id) {
      return $(`.sign-up__step[data-step=${id}]`);
    },
    changeStep: function (step) {
      this.currentStep = step;
      $('.sign-up__step--active').removeClass('sign-up__step--active');
      this.getStep(step).addClass('sign-up__step--active');
    }
  };

  $('.sign-up').submit(function (e) {
    e.preventDefault();
    $(this).parents('.sign-up__step').data('step');
  });
  $('[data-submit-step]').click(function () {
    const nextStep = $(this).data('submit-step');
    let errors = 0;
    signUp.getStep(nextStep - 1).find('input, select').each(function () {
      if (!$(this)[0].checkValidity() || $(this).val() === null) {
        $(this).addClass('--invalid');
        errors += 1;
      } else {
        $(this).removeClass('--invalid');
      }
    });
    console.log(errors);
    if (errors === 0) {
      signUp.changeStep(nextStep);
    }
  });

  $('[data-ff-back]').click(function () {
    signUp.changeStep(signUp.currentStep - 1)
  })

  const zeroStep = document.querySelector('.sign-up__step[data-step="0"]')
  if (zeroStep) {
    if (!zeroStep.classList.contains('sign-up__step--active')) {
      zeroStep.classList.add('sign-up__step--active')
    }
  }
})